import React from "react";
import { COLORS } from "../../theme";
import Icon from "./Icon";

// Círculo pequeno com ícone — usado como "selo" de identificação no
// cabeçalho de cards/seções (ex: "Saldo banco de horas", "Hoje"), no lugar
// de um rótulo só de texto. `cor` é tanto o ícone quanto a base do fundo
// (aplicado com transparência, sem precisar declarar um tom separado).
export default function IconBadge({ icon, size = 34, cor = COLORS.primary, iconSize }) {
  return (
    <div
      style={{
        width: size, height: size, borderRadius: "50%", flexShrink: 0,
        background: cor + "1c", display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <Icon name={icon} size={iconSize || Math.round(size * 0.48)} color={cor} />
    </div>
  );
}
